import CASHIER_USERS from '../desktop/cashiersUsers/page';
import CASHIER_SHIFT from '../desktop/cashiersShift/page';
import REPLENISHMENT_REPORT from '../desktop/replenishment/page/list';
import WITHDRAWALS from '../desktop/withdrawals/page/list';
import GAMER_REPORT from '../desktop/users/page/list';
import GAMER_LIST_ID from '../desktop/users/page/view';
import EVENT_REPORT from '../desktop/report-event/page/list';
import BALANCE_REPORT from '../desktop/report-balance/page/list';
import FINANCE_REPORT from '../desktop/report-finance/page/list';
import GAMER_LIST from '../desktop/search-user/page/list';
import REPLENISHMENT_GAMER_REPORT from '../desktop/gamer-report/page/list';
import INFORMATION from '../desktop/information_panel/page';
import REFERRAL from '../desktop/referrals/page/list';
import REFERRAL_PROMOCODE from '../desktop/referrals/page/view';
import GAMES_PROVIDER_REPORT from '../desktop/report-provider/page/list';
import GAMES_SEARCH from '../desktop/report-provider/page/search';
import BONUS from '../desktop/bonuses/page/list';
import BONUS_TEMPLATE from '../desktop/bonuses/page/select-template';
import BONUS_SETTINGS from '../desktop/bonuses/page/bonus-settings';
import PERSONAL_BONUS from '../desktop/bonus-personal-issue/page/view';
import PERSONAL_BONUS_CREATE from '../desktop/bonus-personal-issue/page/create';
import BONUSES_REPORT from '../desktop/report-bonuses/page/list';
import KYC from '../desktop/kyc/page/list';
import GAMER_REPORT_EVENT from '../desktop/users/page/report-event';
import GAMER_REPORT_GAME from '../desktop/users/page/report-game';
import JACKPOT from '../desktop/jackpot/page/list';
import JACKPOT_CREATE from '../desktop/jackpot/page/create';
import JACKPOT_REPORT from '../desktop/report-jackpot/page/list';
import JACKPOT_EDIT from '../desktop/jackpot/page/edit';
import TOURNAMENT_LIST from '../desktop/tournament/page/list';
import TOURNAMENT_CREATE from '../desktop/tournament/page/create';
import TOURNAMENT_EDIT from '../desktop/tournament/page/edit';
import TOURNAMENT_STAT from '../desktop/tournament/page/stat';
import CASHIER_DAILY from '../desktop/report-daily/page/list';
import CASHIER_DAILY_ID from '../desktop/report-daily/page/view';
import CASHIER_GROUP from '../desktop/report-group/page/list';
import SUPPORT from '../desktop/support/page';
import WITHDRAWALS_OPERATION from '../desktop/report-unconfirmed/page/list';
import PAYMENT_SYSTEM from '../desktop/PaymentSystem/page/list';
import CASHIER_GROUP_ID from '../desktop/report-group/page/view';
import GAMES_CREDIT from '../desktop/credit/page/list';
import LOTTERY_LIST from '../desktop/lottery/page/list';
import LOTTERY_CREATE from '../desktop/lottery/page/create';
import LOTTERY_EDIT from '../desktop/lottery/page/edit';
import LOTTERY_STAT from '../desktop/lottery/page/stat';
import LOTTERY_PRIZE from '../desktop/lottery/page/prize';
import SECURITY_ADMIN_LIST from '../desktop/admin/page/list';
import SECURITY_SIGNIN_HISTORY from '../desktop/admin/page/history';
import SECURITY_EVENT_HISTORY from '../desktop/admin/page/event';
import HISTORY_CREDIT from '../desktop/history-credit/page/list';
import PRESENT_CONFIRMATION from '../desktop/presentConfirmation/page/list';
import KEYS from '../desktop/qiwi/page/view';
import FREESPIN_ISSUE from '../desktop/freespin/page/create';
import FREESPIN_LIST from '../desktop/freespin/page/list';
import FREESPIN_VIEW from '../desktop/freespin/page/view';
import SECURITY_ADMIN_VIEW from '../desktop/admin/page/view';
import OBJECT_ORGANIZATION from '../desktop/organization/page/list';
import FREESPIN_GAME from '../desktop/freespinGame/page/list';
import FREESPIN_GAME_CREATE from '../desktop/freespinGame/page/create';
import FREESPIN_GAME_EDIT from '../desktop/freespinGame/page/edit';
import SETTINGS_MESSANGER from '../desktop/messager/page';
import SETTINGS_MESSANGER_CREATE from '../desktop/messager/page/create';
import SETTINGS_MESSANGER_EDIT from '../desktop/messager/page/edit';
import SETTINGS_EXCHANGE from '../desktop/exchangeRates/page/list';
import SETTINGS_EXCHANGE_CREATE from '../desktop/exchangeRates/page/create';
import SETTINGS_EXCHANGE_EDIT from '../desktop/exchangeRates/page/edit';
import PINSALE from '../desktop/pinsale/list';
import PINSALE_CREATE from '../desktop/pinsale/create';
import STATISTICS from '../desktop/statistics/page/view';
import CODE_COUNTRY_LIST from '../desktop/code-country/list';
import CODE_COUNTRY_CREATE from '../desktop/code-country/create';
import CURRENCY_LIST from '../desktop/currency/list';
import CURRENCY_CREATE from '../desktop/currency/create';
import RULES_LIST from '../desktop/rules/list';
import RULES_CREATE from '../desktop/rules/create';
import DICTIONARY_CREATE from '../desktop/dictionary/create';
import DICTIONARY_LIST from '../desktop/dictionary/list';
import CASHBACK from '../desktop/cashback/page/list';
import GAMES_LIST from '../desktop/games/list';
import GAMES_CREATE from '../desktop/games/create';
import GAMES_EDIT from '../desktop/games/edit';
import PROVIDERS_LIST from '../desktop/providers/list';
import PROVIDERS_CREATE from '../desktop/providers/create';
import PROVIDERS_EDIT from '../desktop/providers/edit';
import REPLENISHMENT_GENERAL_REPORT from '../desktop/general-report/page/list';
import MAILING_LIST from '../desktop/mailing/page/list';
import MAILING_VIEW from '../desktop/mailing/page/view';
import REPLENISHMENT_TRANSACTION from '../desktop/transaction/page/list';

export const ConfigComponents = {
    OBJECT_ORGANIZATION,
    INFORMATION,
    FINANCE_REPORT,
    JACKPOT_REPORT,
    BONUSES_REPORT,
    BALANCE_REPORT,
    EVENT_REPORT,
    JACKPOT,
    JACKPOT_CREATE,
    JACKPOT_EDIT,
    TOURNAMENT_LIST,
    TOURNAMENT_CREATE,
    TOURNAMENT_EDIT,
    TOURNAMENT_STAT,
    REFERRAL,
    REFERRAL_PROMOCODE,
    GAMES_PROVIDER_REPORT,
    GAMES_CREDIT,
    HISTORY_CREDIT,
    GAMES_SEARCH,
    PAYMENT_SYSTEM,
    WITHDRAWALS,
    REPLENISHMENT_REPORT,
    REPLENISHMENT_GAMER_REPORT,
    GAMER_REPORT,
    GAMER_LIST_ID,
    GAMER_LIST,
    GAMER_REPORT_EVENT,
    GAMER_REPORT_GAME,
    KYC,
    BONUS,
    BONUS_TEMPLATE,
    BONUS_SETTINGS,
    PERSONAL_BONUS,
    PERSONAL_BONUS_CREATE,
    PRESENT_CONFIRMATION,
    CASHIER_USERS,
    CASHIER_SHIFT,
    CASHIER_DAILY,
    CASHIER_DAILY_ID,
    CASHIER_GROUP,
    CASHIER_GROUP_ID,
    SUPPORT,
    WITHDRAWALS_OPERATION,
    LOTTERY_LIST,
    LOTTERY_CREATE,
    LOTTERY_EDIT,
    LOTTERY_PRIZE,
    LOTTERY_STAT,
    SECURITY_ADMIN_LIST,
    SECURITY_ADMIN_VIEW,
    SECURITY_SIGNIN_HISTORY,
    SECURITY_EVENT_HISTORY,
    FREESPIN_ISSUE,
    FREESPIN_LIST,
    FREESPIN_VIEW,
    FREESPIN_GAME,
    FREESPIN_GAME_CREATE,
    FREESPIN_GAME_EDIT,
    KEYS,
    SETTINGS_MESSANGER,
    SETTINGS_MESSANGER_CREATE,
    SETTINGS_MESSANGER_EDIT,
    SETTINGS_EXCHANGE,
    SETTINGS_EXCHANGE_CREATE,
    SETTINGS_EXCHANGE_EDIT,
    PINSALE,
    PINSALE_CREATE,
    STATISTICS,
    CODE_COUNTRY_LIST,
    CODE_COUNTRY_CREATE,
    CURRENCY_LIST,
    CURRENCY_CREATE,
    RULES_LIST,
    RULES_CREATE,
    DICTIONARY_LIST,
    DICTIONARY_CREATE,
    CASHBACK,
    GAMES_LIST,
    GAMES_CREATE,
    PROVIDERS_LIST,
    PROVIDERS_CREATE,
    GAMES_EDIT,
    PROVIDERS_EDIT,
    REPLENISHMENT_GENERAL_REPORT,
    MAILING_LIST,
    MAILING_VIEW,
    REPLENISHMENT_TRANSACTION
}